import React, { FunctionComponent } from "react";
import { Input, Label } from "@trussle/external-components";
import { CalculatorTooltip } from "../../calculatorTooltip";

export interface IProps {
  annualSalary?: string;
  partnersSalary?: string;
  totalDeposit?: string;
  totalRegularSpend?: string;
  setAnnualSalary: (value: string) => void;
  setPartnersSalary: (value: string) => void;
  setTotalDeposit: (value: string) => void;
  setTotalRegularSpend: (value: string) => void;
}

export const BorrowForm: FunctionComponent<IProps> = (props) => {
  const {
    annualSalary,
    partnersSalary,
    totalDeposit,
    totalRegularSpend,
    setAnnualSalary,
    setPartnersSalary,
    setTotalDeposit,
    setTotalRegularSpend,
  } = props;

  return (
    <div className="borrowForm">
      <div className="form-group">
        <Label
          title=""
          tooltip={(
            <CalculatorTooltip
              body={(
                <p className="calculator-tooltip-p">
                  Include regular salary (before tax), working tax credit, car
                  allowance, and any other cash benefits.
                </p>
              )}
            />
          )}
          className="calculator-label"
          htmlFor="annualSalary"
        />
        <Input
          variant="currency"
          name="Annual Salary"
          label="Annual Salary"
          inputSize="large"
          id="annualSalary"
          value={annualSalary}
          onChange={(e) => setAnnualSalary(e.target.value)}
          required
          className="calculator-input"
        />
      </div>

      <div className="form-group">
        <Label
          title=""
          tooltip={(
            <CalculatorTooltip body={(
              <p className="calculator-tooltip-p">
                Include regular salary (before tax), working tax credit, car
                allowance, and any other cash benefits.
              </p>
            )}
            />
          )}
          className="calculator-label"
          htmlFor="partnersSalary"
        />
        <Input
          variant="currency"
          name="Partners Salary"
          label="Partner's salary (if applicable)"
          inputSize="large"
          id="partnersSalary"
          type="text"
          value={partnersSalary}
          onChange={(e) => setPartnersSalary(e.target.value)}
        />
      </div>

      <div className="form-group">
        <Label
          title=""
          tooltip={(
            <CalculatorTooltip body={(
              <>
                <p className="calculator-tooltip-p">
                  You’ll need to provide at least a 5% deposit to get a mortgage.
                </p>
                <p className="calculator-tooltip-p">
                  For example, you’d need at minimum £10,000 deposit to buy a
                  £200,000 home.
                </p>
              </>
            )}
            />
          )}
          className="calculator-label"
          htmlFor="totalDeposit"
        />
        <Input
          variant="currency"
          name="Total Deposit"
          label="Deposit amount"
          inputSize="large"
          id="totalDeposit"
          type="text"
          value={totalDeposit}
          onChange={(e) => setTotalDeposit(e.target.value)}
          required
        />
      </div>

      <div className="form-group">
        <Label
          title=""
          tooltip={(
            <CalculatorTooltip body={(
              <>
                <p className="calculator-tooltip-p">
                  Lenders take regular monthly spending into account when deciding
                  how much to lend.
                </p>
                <p className="calculator-tooltip-p">
                  This includes loan repayments, credit cards, childcare fees,
                  pension payments, etc.
                </p>
              </>
            )}
            />
          )}
          className="calculator-label"
          htmlFor="totalRegularSpend"
        />
        <Input
          variant="currency"
          name="Total Regular Spend"
          label="Regular monthly outgoings (optional)"
          inputSize="large"
          id="totalRegularSpend"
          type="text"
          value={totalRegularSpend}
          onChange={(e) => setTotalRegularSpend(e.target.value)}
        />
      </div>
    </div>
  );
};
